import React from "react";

/* Four-point sparkle — marks each membership benefit. */
export const SparkleIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M12 2 L13.5 9 L21 11 L13.5 13 L12 22 L10.5 13 L3 11 L10.5 9 Z" />
  </svg>
);

export default SparkleIcon;
